import {
  getGSTRRepotsUrl,
  getShowBannerPlatformFeePromptUrl,
  getShowBannerPromptUrl,
  getVerifyOTPUrl,
  deleteCredentialUrl,
  getCompanyProfileUrl,
  getCompanyIndentifierUrl,
  getCompanyStatutoryInformationsUrl,
  putStatutoryInformationsUrl,
  uploadComapnyAttachemtmentUrl,
  getSendOTPUrl,
  getCompanyIndentifierIdUrl,
} from '@Src/commons/DynamicUrls';
import {
  GstinCredentialType,
  TypeBankDetails,
  TypeRequestOtp,
  TypeVerifyOtp,
} from '@Src/components/OrganisationProfile/Type';
import { CREDENTIAL_URL } from '@Src/commons/Constants';
import { BASE_FINANCE_URL } from '@Src/commons/ConstantUrls';
import { getCompanyId } from '@Src/commons/Utils/authUtils';
import {
  deleteRequestUms,
  getUms,
  patchUms,
  getFDs,
  postFile,
  postUms,
  postFDs,
  putUms,
  getFinance,
  putFinance,
  postFinance,
} from './baseService';

export const getCompanyProfileAPI = (companyId: string) =>
  getUms({ url: getCompanyProfileUrl(companyId) });

export const getCompanyIdentifierAPI = (companyId: string) =>
  getUms({ url: getCompanyIndentifierUrl(companyId) });

export const getCompanyIdentifierIdAPI = (gstin: string) =>
  getUms({ url: getCompanyIndentifierIdUrl(gstin) });

export const getSendOTP = (data: TypeRequestOtp) =>
  postFDs({ url: getSendOTPUrl(), data });

export const getVerifyOTP = (data: TypeVerifyOtp) =>
  postFDs({ url: getVerifyOTPUrl(), data });

export const getGSTRReports = (companyIdentifierId: number) =>
  getFDs({ url: getGSTRRepotsUrl(companyIdentifierId) });

export const getShowBannerPrompt = (companyId: number) =>
  getFDs({ url: getShowBannerPromptUrl(companyId) });

export const getShowBannerPlatformFeePrompt = (companyId: number) =>
  getUms({ url: getShowBannerPlatformFeePromptUrl(companyId) });

export const uploadOrganisationDocsAPI = (
  keyName: string,
  companyId: string,
  data: string | Blob
) => {
  const formData = new FormData();
  formData.append('file', data);
  const url = uploadComapnyAttachemtmentUrl(keyName, companyId);

  return postFile({ url, data: formData, umsRequest: true });
};

export const getCompanyStatutoryInformationsAPI = (companyId: string) =>
  getUms({ url: getCompanyStatutoryInformationsUrl(companyId) });

export const updateBankDetailsAPI = (
  id: string | number,
  data: TypeBankDetails
) => putUms({ url: putStatutoryInformationsUrl(id), data });

export const getCredentialListAPI = () => getUms({ url: `${CREDENTIAL_URL}` });

export const createCredentialAPI = (data: GstinCredentialType) =>
  postUms({ url: `${CREDENTIAL_URL}`, data });

export const updateCredentialAPI = (data: GstinCredentialType) =>
  patchUms({ url: `${CREDENTIAL_URL}`, data });

export const deleteCredentialAPI = (gstin: string) =>
  deleteRequestUms({ url: deleteCredentialUrl(gstin), data: null });

export const toggleCredentialActivationAPI = (data: GstinCredentialType) =>
  patchUms({ url: `${CREDENTIAL_URL}/activate`, data });

export const getFinanceAccountDetails = (companyId: string) =>
  getFinance(
    { params: { company_id: companyId } },
    `${BASE_FINANCE_URL}/accounts`
  );

export const updateFinanceAccountDetails = (id: string, data: any) =>
  putFinance(`accounts/${id}`, data);

export const createFinanceVirtualAccount = (data: any) =>
  postFinance('virtual-accounts/create', data);

export const updateFinancePrimaryVAN = (data: any) =>
  putFinance(`virtual-accounts/${getCompanyId()}/set-primary`, data);

export const addPayoutAccount = async (data: any) =>
  postUms({ url: 'api/statutory-information', data });

export const deletePayoutAccount = async (id: number) =>
  deleteRequestUms({ url: `statutory-information/${id}`, data: {} });

export const makePrimaryPayoutAccount = async (id: number | string) =>
  patchUms({ url: `statutory-information/${id}/primary`, data: {} });

export const fetchCreditTermsForCompany = async ({
  page = 0,
  per_page = 10,
}: {
  page: number;
  per_page: number;
}) =>
  // params.set("mapping_types", "RM");
  getFinance(
    {
      params: { page, per_page, vendor_id: getCompanyId() },
    },
    `${BASE_FINANCE_URL}/scf-settlement-config`
  );

export const saveCreditTerms = async (data) => {
  const url =
    data.mapping_type === 'RM'
      ? `scf-settlement-config/create-rm-config`
      : `scf-settlement-config`;
  return postFinance(url, data);
};

export const getCompaniesByName = async (name) =>
  getUms({
    url: `/api/v2/companies`,
    params: { name, page_no: 0, per_page: 50 },
  });
